import { useParams } from 'react-router-dom';

import { logError } from 'lib/sentry/logError';

import { SESSION_ATTENDANCE_STATUS } from 'features/sessions/config';
import {
  ScheduledSessionConfigType,
  SessionType,
} from 'features/sessions/config/types';
import { useSessionsQueryActions } from 'features/sessions/hooks/useSessionsQueryActions';

import { showSuccessToast } from 'shared/components/Toast';
import { getUuId } from 'shared/utils/uuid';

export const useSessionsTableScheduleSessionMutateOptions = () => {
  const { getSessionList, updateSessions, cancelQueries } =
    useSessionsQueryActions();
  const { email: userId } = useParams();

  return {
    onMutate: (config: ScheduledSessionConfigType) => {
      cancelQueries();

      const oldSessions = getSessionList();

      const tempSessionId = getUuId();

      const newSession = {
        coachingSessionId: tempSessionId,
        startAt: config.startAt,
        endAt: config.endAt,
        attendance: SESSION_ATTENDANCE_STATUS.SCHEDULED,
        title: 'Coaching session',
      };

      // @ts-ignore
      updateSessions(userId!, [...oldSessions, newSession]);

      return { oldSessions, tempSessionId };
    },
    onSuccess: (
      newSession: SessionType,
      config: ScheduledSessionConfigType,
      context: { oldSessions: SessionType[]; tempSessionId: string }
    ) => {
      if (context) {
        const { tempSessionId } = context;
        const sessions = getSessionList();

        const updatedSessions = sessions.filter(
          (item) => item.coachingSessionId !== tempSessionId
        );

        updateSessions(userId!, [...updatedSessions, newSession]);
      }

      showSuccessToast('Session scheduled successfully.');
    },
    onError: (err: Error, _: any, context: { oldSessions: SessionType[] }) => {
      if (context) {
        updateSessions(userId!, context.oldSessions);
      }
      logError(err);
    },
  };
};
